import { render, staticRenderFns } from "./BaseStatusForm.vue?vue&type=template&id=69add71e&scoped=true&lang=pug&"
import script from "./BaseStatusForm.vue?vue&type=script&lang=js&"
export * from "./BaseStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseStatusForm.vue?vue&type=style&index=0&id=69add71e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69add71e",
  null
  
)

export default component.exports